/*!

 =========================================================
 * Vue Black Dashboard PRO - v1.2.3
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-black-dashboard-pro
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import "regenerator-runtime/runtime";
// Fija el locale de moment y el default de MazPicker.locale ANTES de que se
// evalúe cualquier otro módulo (maz-ui, api-services, rutas). No mover.
import "./plugins/momentLocale";
import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import DashboardPlugin from "./plugins/dashboard-plugin";
import ZohoSalesIQPlugin from "./plugins/zoho-salesiq";
import VueHtml2Canvas from 'vue-html2canvas';
import App from "./App.vue";

// router setup
import router from "./routes/router";
import i18n from "./i18n";

//import './registerServiceWorker'
import wb from "./registerServiceWorker";

Vue.prototype.$workbox = wb;

//FontAwesome
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import Vuelidate from "vuelidate";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("email", email);
//extend("phone", phone);
extend("required", required);
extend("min", min);
/*
import axios from 'axios'
import VueAxios from 'vue-axios'
*/
import { localize } from "vee-validate";

// Install English and Arabic locales.
localize("es");
//aplication Insights
import VueAppInsights from "vue-application-insights";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(Vuelidate);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
import Base from "@/api-services/base";
import MsalService from "@/api-services/msal.service";
import { PuedeAccederPlan } from "@/util/planes";
import AccesoNom035 from "@/api-services/nom035stps2018.acceso.service";
import VueSignalR from "@latelier/vue-signalr";

import { default as msal, CachePolicyLookup } from "vue-msal-browser";

Vue.use(msal, MsalService.config);

import SuscripcionesUsuarios from "@/api-services/suscripciones.usuarios.service";

Vue.prototype.$SuscripcionesUsuarios = SuscripcionesUsuarios;
Vue.prototype.$Prueba = { Parametro: "23456" };
Vue.prototype.$PerfilLocal = { usuario: {}, propiedades: {} };
Vue.use(VueSignalR, Base.SignalRURL);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(ZohoSalesIQPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueHtml2Canvas);
Vue.use(VueAppInsights, {
  id: "3854059a-d5d3-4816-b4ee-67e48334c8f7",
  router,
  appInsightsConfig: {
    accountId: "-1",
    loggingLevelConsole: 2,
    autoTrackPageVisitTime: true,
  },
  accountId: -1,
});

//http://localhost:8080/#/empleado
///Redirigir a Login si no ha iniciado sesión
router.beforeEach((to, from, next) => {
  console.debug(from);
  const currentUser = localStorage.sesion;
  console.debug(to);
  var requiresAuth =
    to.matched.some((record) => record.meta.requiresAuth) ||
    //to.path.indexOf("/state=") == 0 ||
    to.path == "/login";
  //Mueve al inicio el scroll al cambiar de página
  const container = document.querySelector(".main-panel");
  if (container) container.scrollTop = 0;

  //NOM-035: quien llega con su enlace y ya comprobó su identidad no tiene sesión, así
  //que la guarda de siempre lo mandaría a un login que no puede completar. Va antes de
  //recalcular requiresAuth, que es donde se decide eso.
  //
  //Es comodidad, no seguridad —igual que PermitePlan—: la puerta está en el API, que
  //vuelve a comprobar la huella del token en cada llamada. Si alguien edita a mano el
  //espacio del navegador, entra a una pantalla que no va a poder cargar.
  if (to.matched.some((record) => record.meta.requiereValidacionNom035)) {
    const SinSesion = currentUser == null || currentUser == "";
    const EvaluacionID = to.params.nom035Stps2018EvaluacionID;
    if (SinSesion) {
      if (AccesoNom035.EsAccesoValido(EvaluacionID)) {
        next();
        return;
      }
      //Sin prueba se regresa a la invitación, que es la pantalla que sabe pedirla. Si
      //tampoco está la referencia, ahí se dibuja "no encontramos tu invitación".
      next(`/nom035stps2018/invitacion-empleado/${EvaluacionID || ""}`);
      return;
    }
  }

  // ! idea Alberca checar
  if (requiresAuth)
    requiresAuth =
      currentUser == null || currentUser == "" || localStorage.EsSSO == 1;

  if (!requiresAuth) {
    if (!PermitePlan(to)) {
      next("/");
      return;
    }
    if (!RequiereColaborador(to)) {
      //A "/main/home" y no a "/": Default.vue manda a /empleado a quien tenga
      //perfil Colaborador, y /empleado es justo lo que se está bloqueando, así
      //que "/" haría un ciclo infinito. /main/home no tiene restricciones.
      next("/main/home");
      return;
    }
    next();
    return;
  }
  if (requiresAuth) {
    MsalService.handleRedirectPromise(Vue.prototype.$msal, next);

    return;
  }
});

/**
 * Resuelve la restricción por plan de una ruta.
 *
 * Sustituye a las 19 guardas `beforeMount` que cada página traía copiada. La
 * regla vive en `meta.plan` de la ruta (ver src/routes/routes.js) y se evalúa en
 * src/util/planes.js.
 *
 * TODO(entitlements): esto es sólo comodidad para el usuario, no seguridad. La
 * API no valida el plan en ningún endpoint (ver el TODO en BaseController.Puede
 * del repo eClock6), así que quien conozca la URL de la API entra igual. Cuando
 * exista la tabla de entitlements, esta guarda debe alimentarse de los permisos
 * que devuelva el backend y no de una tabla de planes en el front.
 */
function PermitePlan(to) {
  const Regla = to.matched
    .map((record) => record.meta && record.meta.plan)
    .filter((plan) => plan != null)
    .pop();
  if (Regla == null) return true;

  let Plan = "";
  try {
    Plan = SuscripcionesUsuarios.getPlan();
  } catch (e) {
    // El perfil todavía no está en localStorage (deep link, sesión recién
    // abierta). Sin plan no se puede decidir: se deja pasar.
    console.debug("PermitePlan: plan no disponible todavía", e);
    return true;
  }

  return PuedeAccederPlan(Plan, Regla);
}

/**
 * Resuelve la restricción "hay que estar dado de alta en la cuenta" de una ruta.
 *
 * El autoservicio es personal: quien no es colaborador de la suscripción
 * seleccionada no tiene un autoservicio que mostrar. La regla vive en
 * `meta.requiereColaborador` de la ruta (ver src/routes/routes.js).
 *
 * Existe por el incidente del 2026-08-09: un SuperAdministrador abría el
 * autoservicio de una cuenta ajena y la API lo resolvía como el primer
 * administrador de esa cuenta, sobrescribiéndole su UsuarioID. Ojo con
 * `esSuperAdministrador`: el front lo trata como "Administrador" en
 * suscripciones.usuarios.service.js, así que el perfil NO sirve para decidir
 * esto; lo que decide es tener ColaboradorID propio, y un superadmin en una
 * cuenta donde no está dado de alta no lo tiene.
 *
 * TODO(entitlements): igual que `PermitePlan`, esto es comodidad para el
 * usuario, no seguridad —quien conozca la URL de la API entra igual. La guarda
 * de verdad es del backend (eClock6, BaseController.ObtenColaboradorID).
 */
function RequiereColaborador(to) {
  const Regla = to.matched.some(
    (record) => record.meta && record.meta.requiereColaborador
  );
  if (!Regla) return true;

  try {
    // Sin perfil cargado (deep link, sesión recién abierta) no se puede decidir:
    // se deja pasar y la API responde 404 si de verdad no le toca. Importa
    // distinguirlo de "cargado y sin colaborador", que sí se bloquea.
    if (SuscripcionesUsuarios.getPerfilLocal() == null) return true;

    const ColaboradorID = SuscripcionesUsuarios.getColaboradorID();
    return ColaboradorID != null && ColaboradorID != "";
  } catch (e) {
    console.debug("RequiereColaborador: perfil no disponible todavía", e);
    return true;
  }
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  // store,
  i18n,
}); //.$mount('#app');

localize({
  es: {
    messages: {
      // generic rule messages...
    },
    fields: {
      fullname: {
        required: "Requerimos tu nombre completo",
      },
      whatsapp: {
        required: "Requerimos tu número de celular",
        min: "A 10 digitos, te enviaremos un SMS para validarlo",
      },
      email: {
        required:
          "Requerimos tu correo electrónico, lo validaremos enviandote un email",
      },
      password: {
        required: "Se requiere contraseña",
        min: "La contraseña debe ser mínimo de {length} caracteres",
      },
    },
  },
});
